import { HttpParams } from '@angular/common/http';

export const createRequestOption = (req?: any): HttpParams => {
	let options: HttpParams = new HttpParams();

	if (req) {
		Object.keys(req).forEach((key) => {
			if (key !== 'sort' && req[key]) {
				for (const value of [].concat(req[key]).filter((v) => v !== '')) {
					let reqKey = key;
					let reqValue = value;
					if (key === 'query') {
						const _valueParams = value.split('&');
						if (_valueParams.length > 0) {
							_valueParams.forEach((_itemParam) => {
								const _value = _itemParam.split('=');
								reqKey = _value[0];
								reqValue = _value[1];
								options = options.append(reqKey, reqValue);
							});
						} else {
							const _value = value.split('=');
							reqKey = _value[0];
							reqValue = _value[1];
							options = options.append(reqKey, reqValue);
						}
					}
				}
			}
		});

		if (req.sort) {
			req.sort.forEach((val: string) => {
				options = options.append('sort', val);
			});
		}
	}
	return options;
};
